import { Selector } from '@ngxs/store';
import { AppState } from './app.state';
import { AppStateModel } from '@app/shared/state/app-state.model';

export class AppSelectors {
  @Selector([AppState])
  public static updatedLegalTermsDate(state: AppStateModel): string {
    return state.updatedLegalTermsDate;
  }

  @Selector([AppState])
  public static updatedPrivacyPolicyDate(state: AppStateModel): string {
    return state.updatedPrivacyPolicyDate;
  }
}
